export default "__VITE_PUBLIC_ASSET__065a338e__"